import React from 'react';
import Reflux from 'reflux';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { Row, Col, Button } from 'bootstrap';
import { Map } from 'immutable';
import role from 'shared/lib/role';
import classnames from 'classnames';
import draftjsUtils from '@shoflo-rundown/draft-js-utils';
import cellHelper from 'main/components/show/cuesheet/cellHelper';
import {
  ZoomPercentages,
  PlaceholderText,
  populatePrompterSettingsWithDefaults,
} from 'shared/constants/FeaturedEditorConstants';
import { getCompactItemCellWidthValue } from '../cuesheet/rowWidthHelper';
import {
  EditableCellTypes,
  CompactSpecialColumnWidths,
} from 'flux/stores/cuesheet/CuesheetConstants';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import RTEEditor from 'shared/components/rte/rteEditor';
import ColumnMenu from 'shared/components/menus/columns';
import StartTime from 'main/components/show/cuesheet.featured/startTime';
import PresetTime from 'main/components/show/cuesheet.featured/presetTime';
import Duration from 'main/components/show/cuesheet.featured/duration';
import CellHistoryIcon from 'main/components/show/cuesheet/cellHistoryIcon.jsx';
import UserSessionStore from 'flux/stores/UserSessionStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import PermissionStore from 'flux/stores/PermissionStore';
import CuesheetColumnActions from 'flux/actions/cuesheet/CuesheetColumnActions';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import CuesheetTransientCellActions from 'flux/actions/cuesheet/CuesheetTransientCellActions';
import CuesheetCursorActions from 'flux/actions/cuesheet/CuesheetCursorActions';
import RouteActions from 'flux/actions/RouteActions';
import CuesheetHelper from 'flux/helpers/cuesheetHelper';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';
import Slider from 'rc-slider';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

const { createSliderWithTooltip } = Slider;
const TooltipSlider = createSliderWithTooltip(Slider);
const defaultRteText = PlaceholderText;

export default React.createClass({
  displayName: 'FeaturedEditor',

  mixins: [
    Reflux.ListenerMixin,
    Reflux.connect(CuesheetStore, 'cuesheet'),
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connect(PermissionStore, 'permissions'),
    PureRenderMixin,
  ],

  getInitialState() {
    return {};
  },

  componentWillMount() {
    // Initialize the ref
    this.wrapperRef = null;
  },

  componentDidMount() {
    window.addEventListener('resize', this._handleEditorWidthChange);
    this.listenTo(
      CuesheetColumnActions.updateItemColumnWidth,
      this._handleEditorWidthChange,
    );

    // Add the event listener when the component mounts
    window.addEventListener('mousedown', this._handleDocumentClick);
  },

  componentWillUnmount() {
    window.removeEventListener('resize', this._handleEditorWidthChange);
    window.removeEventListener('mousedown', this._handleDocumentClick);
  },

  componentDidUpdate(prevProps, prevState) {
    if (this.state.cuesheet) {
      if (
        this.state.cuesheet.get('show') &&
        (!prevState.cuesheet || !prevState.cuesheet.get('show'))
      ) {
        this._handleEditorWidthChange();
      }

      if (
        this.state.cuesheet.get('settings') &&
        (!prevState.cuesheet || !prevState.cuesheet.get('settings'))
      ) {
        this._handleEditorWidthChange();
      }
    }
  },

  render() {
    const state = this.state.cuesheet,
      rows = state.get('rows'),
      columns = state.get('fullColumns'),
      columnId = state.getIn(['userSettings', 'featuredColumn']),
      rowIndex = this._getSelectedRowIndex();

    const editorWidth = this.state.editorWidth,
      placeholderHeight = this._getHeight();

    let editorNode =
      columnId && rowIndex >= -1 ? (
        this._getEditor()
      ) : (
        <PlaceholderStateless
          styles={{ width: editorWidth, height: placeholderHeight }}
          columnSelected={columnId}
        />
      );

    //Show loading indicator until rows are there
    if (!rows || !rows.size || state.get('loading')) return null;

    const rowSpec = this._getSelectedRowSpec();

    const isEditing = !rowSpec
      ? false
      : rowSpec.getIn(['editing', 'value']) === columnId;

    return (
      <div
        style={{ height: placeholderHeight }}
        className={classnames('featured-editor-wrapper')}
      >
        <Header
          {...{ isEditing, columns }}
          onSave={() => this._handleStopEditing(this.state.rteState)}
          onCancel={this._handleCancelEditing}
          activeColumnId={columnId}
          onColumnChange={this._handleFeaturedColumnChange}
        />
        {editorNode}
      </div>
    );
  },

  _handleFeaturedColumnChange(columnId) {
    CuesheetColumnActions.saveFeaturedColumn(columnId);
  },

  _handleFeaturedZoomChange(zoom) {
    CuesheetCellActions.saveFeaturedZoom(zoom);
  },

  _handleEditorWidthChange() {
    this.setState({ editorWidth: this._getCalculatedEditorWidth() });
  },

  _handleDocumentClick(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      // The click is outside the featuredEditorWrapper
      this._handleBlur();
    }
  },

  _getDefaultRTEText() {
    return this._isEventContributor() ? defaultRteText : '(empty cell)';
  },

  _isEventContributor() {
    const { cuesheet, user } = this.state;
    const teamId = cuesheet.get('teamId');
    const eventId = cuesheet.get('eventId');

    return role.hasEventContributorRole(user, teamId, eventId);
  },

  _getEditor() {
    const state = this.state.cuesheet,
      columnId = state.getIn(['userSettings', 'featuredColumn']),
      show = state.get('show'),
      event = state.get('event'),
      eventId = state.get('eventId'),
      teamId = state.get('teamId'),
      item = this._getSelectedRowItem(),
      rowId = this._getSelectedRowId(),
      rowSpec = this._getSelectedRowSpec(),
      rowIndex = this._getSelectedRowIndex(),
      editorWidth = this.state.editorWidth;

    const prompterSettings = populatePrompterSettingsWithDefaults(
      state.get('userSettings'),
    );

    const zoom = prompterSettings.zoom,
      lineHeight = prompterSettings.lineHeight,
      fontWeight = prompterSettings.fontWeight,
      capitalization = prompterSettings.capitalization,
      singleItem = prompterSettings.singleItem,
      itemInfo = prompterSettings.itemInfo;

    if (!item) return null;

    let isEditing = rowSpec.getIn(['editing', 'value']) === columnId,
      isSelected = CuesheetHelper.isCellSelected(rowIndex, columnId, state),
      wrapperClassName = '';

    let editorHeight = this._getEditorHeight(),
      readOnlyHeight = editorHeight,
      editorRTEState = this._getFeaturedRTEState(item, columnId);

    const isDefaultEditorRteState = !editorRTEState;

    if (editorWidth <= 440) {
      wrapperClassName = 'narrow-rte-wrapper';
      editorHeight -= 34;
    }

    const hasTeleprompterPermission =
      this.state.permissions.get('teleprompter');

    return (
      <div
        tabIndex="-1"
        style={{ width: editorWidth }}
        className={classnames('featured-editor', {
          'featured-editor-default-text': isDefaultEditorRteState,
        })}
        ref={(node) => {
          this.wrapperRef = node;
        }}
      >
        <Row>
          <EditorHeader
            {...{
              teamId,
              rowId,
              eventId,
              event,
              show,
              rowIndex,
              item,
              columnId,
              zoom,
              lineHeight,
              fontWeight,
              capitalization,
              singleItem,
              itemInfo,
              isEditing,
              hasTeleprompterPermission,
            }}
            onSave={() => this._handleStopEditing(this.state.rteState)}
            onCancel={this._handleCancelEditing}
            onZoomChange={(i) => {
              this._handleFeaturedZoomChange(ZoomPercentages[i]);
            }}
          />
        </Row>
        <Row>
          <Col className={this._getEditorZoomClassName()} md={24}>
            <RTEEditor
              viewType="featured"
              height={editorHeight}
              readOnlyHeight={readOnlyHeight}
              isEditing={isEditing}
              isSelected={isSelected}
              wrapperClassName={wrapperClassName}
              onSelect={CuesheetCellActions.selectFeaturedCell}
              onStartEdit={CuesheetCellActions.startEditingFeaturedCell}
              onStopEdit={this._handleStopEditing}
              rteState={editorRTEState}
              onExternalContentChange={this._handleExternalContentChange}
              placeholder={this._getDefaultRTEText()}
            />
          </Col>
        </Row>
      </div>
    );
  },

  _getEditorZoomClassName() {
    const state = this.state.cuesheet,
      zoom =
        state.getIn(['userSettings', 'featuredZoom']) || ZoomPercentages[4];

    return `featured-editor-zoom-${zoom}`;
  },

  // Handle the click outside logic
  _handleBlur() {
    const state = this.state.cuesheet,
      columnId = state.getIn(['userSettings', 'featuredColumn']),
      rowSpec = this._getSelectedRowSpec();

    const isEditing = rowSpec.getIn(['editing', 'value']) === columnId;

    if (!isEditing) return;

    this._handleStopEditing(this.state.rteState);
  },

  _handleExternalContentChange(rteState) {
    this.setState({ rteState });
  },

  _handleCancelEditing(e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ rteState: null });

    this._resetFeaturedCellEditingState();
  },

  _handleStopEditing(rteState) {
    const state = this.state.cuesheet,
      columnId = state.getIn(['userSettings', 'featuredColumn']);
    // rowIndex = this._getSelectedRowIndex();
    const rowSpec = this._getSelectedRowSpec();
    const rowId = rowSpec.get('path')[2];

    const cellSpec = Map({ type: EditableCellTypes.Data, value: columnId });

    CuesheetCellActions.saveDataCellChanges(rowId, cellSpec, rteState);

    this._resetFeaturedCellEditingState();
  },

  _resetFeaturedCellEditingState() {
    CuesheetTransientCellActions.clearTransientCellValue();
    CuesheetCursorActions.clearEditing();
    CuesheetCellActions.selectItemCell(
      this._getSelectedRowIndex(),
      EditableCellTypes.ItemTitle,
    );
  },

  _getFeaturedRTEState(item, columnId) {
    const rteState = item.getIn(['cells', columnId, 'rteState']);

    return rteState && draftjsUtils.getPlainTextFromRawRTEState(rteState.toJS())
      ? rteState
      : null;
  },

  _getSelectedRowItem() {
    const state = this.state.cuesheet,
      rowSpec = this._getSelectedRowSpec();

    if (!rowSpec) return null;

    return state.getIn(['rowMap'].concat(rowSpec.get('path')));
  },

  _getSelectedRowSpec() {
    const state = this.state.cuesheet;

    if (!state.has('rows')) return null;

    const rowIndex = this._getSelectedRowIndex();
    const rowSpec = state.get('rows').get(rowIndex);

    return rowSpec;
  },

  _getSelectedRowId() {
    const state = this.state.cuesheet;

    if (!state.has('rows')) return null;

    const rowIndex = this._getSelectedRowIndex();
    const rowId = state.get('rows').getIn([rowIndex, 'path'])[2];

    return rowId;
  },

  _getSelectedRowIndex() {
    const state = this.state.cuesheet;
    return state.get('featuredCellRowIndex');
  },

  /**
   * Calculate some editor properties
   */
  _getCalculatedEditorWidth() {
    const show = this.state.cuesheet.get('show'),
      settings = this.state.cuesheet.get('settings');

    if (!show) return {};

    const displayStartTime = show.get('displayStartTime'),
      displayPresetDuration = show.get('displayPresetDuration'),
      displayDuration = show.get('displayDuration'),
      padding = 32;

    let tableWidth = getCompactItemCellWidthValue(settings);

    if (displayStartTime) tableWidth += CompactSpecialColumnWidths.Start;
    if (displayPresetDuration) tableWidth += CompactSpecialColumnWidths.Preset;
    if (displayDuration) tableWidth += CompactSpecialColumnWidths.Duration;
    tableWidth += CompactSpecialColumnWidths.RowMenuBar;
    tableWidth += CompactSpecialColumnWidths.Featured;

    // for rounding errors at different zooms
    tableWidth = Math.ceil(tableWidth) + 5;

    const docEl = document.documentElement;
    const { innerWidth } = window;

    const gridWidth = Math.max(docEl.clientWidth, innerWidth || 0);

    const width = gridWidth - tableWidth - padding - 100;

    return width;
  },

  _getHeight() {
    const innerHeight = window.innerHeight;
    const showHeader = document.getElementById('cs-header');
    const showFooter = document.getElementById('cs-footer');
    const buffer = 2;

    const showHeaderHeight = showHeader ? showHeader.offsetHeight : 69;
    const showFooterHeight = showFooter ? showFooter.offsetHeight : 68;

    const newHeight =
      innerHeight + buffer - showHeaderHeight - showFooterHeight;

    return newHeight;
  },

  _getEditorHeight() {
    const height = this._getHeight();
    const featuredHeader =
      document.getElementsByClassName('featured-header')[0];
    const featuredEditorHeader = document.getElementsByClassName(
      'featured-editor-header',
    )[0];

    const featuredHeaderHeight = featuredHeader
      ? featuredHeader.offsetHeight
      : 33;
    const featuredEditorHeaderHeight = featuredEditorHeader
      ? featuredEditorHeader.offsetHeight
      : 117;

    return height - featuredHeaderHeight - featuredEditorHeaderHeight;
  },
});

const DisplayTimeNode = ({ children, display }) => {
  if (!display) return null;
  return children;
};

const EditorHeader = ({
  event,
  eventId,
  show,
  item,
  teamId,
  rowId,
  rowIndex,
  columnId,
  zoom,
  lineHeight,
  fontWeight,
  capitalization,
  singleItem,
  itemInfo,
  isEditing,
  onZoomChange,
  // hasTeleprompterPermission
}) => {
  if (!event) return null;

  const displayStartTimeClock = item.get('displayStartTimeClock');
  const displayDurationClock = item.get('displayDurationClock');
  const displayPresetClock = item.get('displayPresetClock');

  const showId = show.get('_id');

  const showStartOn = show.get('startOn'),
    timeZone = event.get('timeZone'),
    twentyFourHourClock = event.get('twentyFourHourClock'),
    cellSpec = Map({ type: EditableCellTypes.Data, value: columnId });

  const zoomIndex = zoom
    ? Object.keys(ZoomPercentages).findIndex((i) => {
        return ZoomPercentages[i] === zoom;
      }) + 1
    : 4;

  // const lineHeightIndex = lineHeight ? Object.keys(LineHeightPercentages).findIndex((i) => {
  //   return LineHeightPercentages[i] === lineHeight;
  // }) + 1 : 1;

  const teleprompterAction = () => {
    RouteActions.goToTeleprompter(
      { teamId, eventId, showId, rowId, columnId },
      { zoom, lineHeight, fontWeight, capitalization, singleItem, itemInfo },
    );
  };

  const utilNodes = isEditing ? null : (
    <div>
      <Col
        xsOffset={3}
        xs={10}
        smOffset={6}
        sm={8}
        mdOffset={8}
        md={10}
        className="featured-editor-header-zoom-slider"
      >
        <TooltipSlider
          min={1}
          max={Object.keys(ZoomPercentages).length}
          step={1}
          defaultValue={zoomIndex !== -1 ? zoomIndex + 1 : 4}
          onChange={onZoomChange}
        />
      </Col>
      <Col xs={3} sm={3} md={3} className="featured-editor-header-icons">
        <WithTooltip
          placement="bottom"
          tip={TooltipConstants.TeleprompterView}
          delay={0}
        >
          <div className="featured-editor-header-icons__fullscreen">
            <Icon name="arrows-alt" onClick={teleprompterAction} />
          </div>
        </WithTooltip>
        <CellHistoryIcon
          onClick={() =>
            CuesheetCellActions.showCellHistory(rowIndex, cellSpec)
          }
        />
      </Col>
    </div>
  );

  return (
    <Col md={24} className="featured-editor-header">
      <Row>
        <Col xs={6} sm={5} md={2} className="featured-editor-header-number">
          {item.get('numberAdjusted')}
        </Col>
        {utilNodes}
      </Row>
      <Row>
        <Col sm={24} md={14} className="featured-editor-header-title">
          {cellHelper.getNodesWithLineBreaks(item.get('title') || 'Item')}
        </Col>
        <Col sm={24} md={10} className="featured-editor-header-time-wrapper">
          <div className="featured-editor-header-time">
            <DisplayTimeNode
              display={show.get('displayStartTime') && displayStartTimeClock}
            >
              <StartTime
                {...{
                  item,
                  rowIndex,
                  twentyFourHourClock,
                  timeZone,
                  showStartOn,
                }}
              />
            </DisplayTimeNode>
          </div>
          <div className="featured-editor-header-time">
            <DisplayTimeNode
              display={show.get('displayPresetDuration') && displayPresetClock}
            >
              <PresetTime
                presetDurationDisplayType={show.get(
                  'presetDurationDisplayType',
                )}
                {...{ item }}
              />
            </DisplayTimeNode>
          </div>
          <div className="featured-editor-header-time">
            {displayDurationClock && show.get('displayDuration') ? (
              <Duration {...{ item }} />
            ) : null}
          </div>
        </Col>
      </Row>
    </Col>
  );
};

const Header = ({
  columns,
  activeColumnId,
  onColumnChange,
  isEditing,
  onSave,
  onCancel,
}) => {
  let actionNodes =
    isEditing && onSave && onCancel ? (
      <div className="pull-right">
        <Button className="featured-editor-header-save-btn" onClick={onSave}>
          Save
        </Button>
        <Button
          className="featured-editor-header-cancel-btn"
          id="btn-cancel"
          onMouseDown={onCancel}
        >
          Cancel
        </Button>
      </div>
    ) : null;

  return (
    <div className="featured-header">
      <span>
        <ColumnMenu
          columns={columns}
          activeId={activeColumnId}
          onChange={onColumnChange}
        />
      </span>
      <span className="featured-info-icon">
        <a
          href="https://shoflo.tv/featured-column-view/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon name="info-circle" />
        </a>
      </span>
      {actionNodes}
    </div>
  );
};

const PlaceholderStateless = ({ styles, columnSelected }) => {
  return (
    <Col style={styles} className="featured-editor-placeholder" md={24}>
      <Row className="featured-editor-placeholder-line-wrapper">
        <PlaceholderLineThin col={1} />
      </Row>
      <Row className="featured-editor-placeholder-line-wrapper">
        <PlaceholderLine col={4} />
        <PlaceholderLineThin col={2} classes={'pull-right'} />
        <PlaceholderLineThin col={2} classes={'pull-right'} />
      </Row>
      <Row className="featured-editor-placeholder-line-wrapper">
        <Col md={24}>
          {columnSelected ? (
            <h3>
              Select a row to the left that has script content to see it here
            </h3>
          ) : (
            <h3>Select featured column above</h3>
          )}
        </Col>
      </Row>
      <Row className="featured-editor-placeholder-line-wrapper-body">
        <PlaceholderLine col={24} />
        <PlaceholderLine col={24} />
        <PlaceholderLine col={24} />
        <PlaceholderLine col={24} />
        <PlaceholderLine col={24} />
      </Row>
    </Col>
  );
};

const PlaceholderLine = ({ col, classes }) => {
  return (
    <Col
      className={classnames('featured-editor-placeholder-line', classes)}
      md={col}
    />
  );
};

const PlaceholderLineThin = ({ col, classes }) => {
  return (
    <Col
      className={classnames('featured-editor-placeholder-line-thin', classes)}
      md={col}
    />
  );
};
